var _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageLoadingRipple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "204px",
    height: "204px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#3b4368",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.2048192771084336s",
    values: "0;38",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1.2048192771084336s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "0s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#689cc5",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.2048192771084336s",
    values: "0;38",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "-0.6024096385542168s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1.2048192771084336s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "-0.6024096385542168s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLoadingRipple);
export default __webpack_public_path__ + "static/media/Image_Loading_Ripple.8ed8147e06a23d209b0fd660c7446dd0.svg";
export { ForwardRef as ReactComponent };